import React, { createContext, useEffect, useMemo, useState } from "react";
import { Redirect, Route } from "react-router-dom";

import useFetchGeo, { IFetchGeoResponse } from "../features/geo/useFetchGeo";

export interface IGeoState {
  geo?: IFetchGeoResponse;
}

export interface IGeoContext {
  geo?: IFetchGeoResponse;
}

export const GeoContext = createContext<IGeoContext>({});

export const GeoProvider: React.FC = ({ children, ...rest }) => {
  const [state, setState] = useState<IGeoState>({});

  const geo = useFetchGeo();

  useEffect(() => {
    if (geo.isSuccess) {
      setState((state) => ({
        ...state,
        geo: geo.data,
      }));
    }
  }, [geo.isSuccess, geo.data]);

  const value = useMemo(
    () => ({
      ...state,
    }),
    [state]
  );

  const renderRoute = () => {
    if (
      state.geo?.status_code === 451 &&
      location.pathname !== "/unavailable" &&
      location.pathname !== "/t/account/notifications/unsubscribe"
    ) {
      return <Redirect to="/unavailable" />;
    }

    return <>{children}</>;
  };

  return (
    <GeoContext.Provider value={value}>
      <Route {...rest} render={renderRoute} />
    </GeoContext.Provider>
  );
};
